import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import adminService from '../../services/adminService';
import '../monitoring/Monitoring.css';

const ORG_TYPE_LABEL = {
  developer: 'Developer',
  consultant: 'Consultant',
  regulator: 'Regulator',
};

const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : '—');

/**
 * Platform-wide view for super_admin accounts (see routes/admin.js) - the
 * one role that isn't scoped to a single organisation. Shows every
 * organisation on the platform and how many users/projects each has.
 */
const PlatformOrganisations = () => {
  const [organisations, setOrganisations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await adminService.getOrganisations({ limit: 100 });
        setOrganisations(data.organisations || []);
      } catch (error) {
        console.error('Failed to load organisations:', error);
        toast.error(error.response?.data?.error || 'Failed to load organisations');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const totalUsers = organisations.reduce((sum, o) => sum + o.userCount, 0);
  const totalProjects = organisations.reduce((sum, o) => sum + o.projectCount, 0);

  return (
    <div className="monitoring-page">
      <div className="monitoring-header">
        <div>
          <h1><i className="fas fa-globe"></i> Organisations</h1>
          <p className="header-subtitle">Every organisation on the platform, with their user and project counts</p>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card total">
          <div className="stat-icon"><i className="fas fa-building"></i></div>
          <div><div className="stat-label">Total Organisations</div><div className="stat-value">{organisations.length}</div></div>
        </div>
        <div className="stat-card success">
          <div className="stat-icon"><i className="fas fa-users"></i></div>
          <div><div className="stat-label">Total Users</div><div className="stat-value">{totalUsers}</div></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon"><i className="fas fa-project-diagram"></i></div>
          <div><div className="stat-label">Total Projects</div><div className="stat-value">{totalProjects}</div></div>
        </div>
      </div>

      {loading ? (
        <div className="empty-state">
          <i className="fas fa-spinner fa-spin"></i>
          <h3>Loading organisations...</h3>
        </div>
      ) : organisations.length === 0 ? (
        <div className="empty-state">
          <i className="fas fa-building"></i>
          <h3>No organisations yet</h3>
        </div>
      ) : (
        <table className="parameter-table">
          <thead>
            <tr>
              <th>Organisation</th><th>Type</th><th>Users</th><th>Projects</th><th>Created</th>
            </tr>
          </thead>
          <tbody>
            {organisations.map((org) => (
              <tr key={org.id}>
                <td>{org.name}</td>
                <td><span className="category-badge">{ORG_TYPE_LABEL[org.type] || org.type}</span></td>
                <td>{org.userCount}</td>
                <td>{org.projectCount}</td>
                <td>{formatDate(org.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PlatformOrganisations;
